<template>
  <div class="animated fadeIn">
    <b-row v-if="!hideAllFilters">
      <b-col lg="12">
        <b-card>
          <div class="row">
            <div class="col">
              <Filters
                :filters="filters"
                :applying="applying"
                v-on:apply="apply()"
                :hideCompany="filterDisplay.hideCompany"
                :hideRegion="filterDisplay.hideRegion"
                :hideBranch="filterDisplay.hideBranch"
                :hideDevice="filterDisplay.hideDevice"
                :hideDate="filterDisplay.hideDate"
                :allowAllCompanies="false"
              ></Filters>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-button variant="success" v-on:click="goTo('/ads/add')"
            ><i class="fa fa-plus"></i> Add New Ad</b-button
          >
        </b-card>
        <b-card>
          <div class="card-header"><i class="fa fa-align-justify"></i> Ads</div>
          <div v-if="!tableReady" class="table-loading-container">
            <img
              src="/img/wifi-loading.gif"
              alt="loading"
              class="loading-table"
            />
          </div>
          <div v-if="tableReady">
            <AdList
              :ads="activeAds"
              :emptyMessage="'No Ads'"
              v-on:getItems="getItems()"
            ></AdList>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Expired Ads
          </div>
          <div v-if="!tableReady" class="table-loading-container">
            <img
              src="/img/wifi-loading.gif"
              alt="loading"
              class="loading-table"
            />
          </div>
          <div v-if="tableReady">
            <AdList
              :ads="expiredAds"
              :emptyMessage="'No Expired Ads'"
              v-on:getItems="getItems()"
            ></AdList>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import common from "./../../mixins/common";
import filter from "./../../mixins/filter";
import AdList from "@/views/ads/AdList";
import Filters from "@/views/common/Filters";

export default {
  name: "ads",
  data() {
    return {
      tableReady: false
    };
  },
  mixins: [common, filter],
  components: {
    AdList,
    Filters
  },
  computed: {
    activeAds() {
      return this.$store.getters.activeAds;
    },
    expiredAds() {
      return this.$store.getters.expiredAds;
    }
  },
  methods: {
    getItems: function() {
      let scope = this;
      scope.tableReady = false;
      let where = {
        company: scope.filters.company
      };
      where = "&where=" + JSON.stringify(where);
      scope.$store.dispatch("getAds", where).then(
        result => {
          scope.tableReady = true;
        },
        error => {
          console.log(error);
        }
      );
    },
    apply() {
      let scope = this;
      if (scope.validate()) {
        scope.getItems();
      }
    },
    validate() {
      if (this.filters.fromDate === "" || this.filters.toDate === "") {
        this.showToast("Select a valid date range", "error");
        return false;
      }
      return true;
    }
  },
  created() {
    this.setupFilter();
    this.getItems();
  }
};
</script>
